import React, { useEffect, useState } from "react";
import useReviews from "../../Hooks/useReviews";
import Review from "../Review/Review";

const Reviews = () => {
  const [reviews, setReviews] = useReviews();

  return (
    <div>
      <div className="container mx-auto row row-cols-2 row-cols-lg-4 g-2 ">
        {reviews.map((review) => (
          <Review reviewData={review} key={review.id}></Review>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
